import { useId } from "react";
import type { IconProps } from "~/design-system/types";

export function InstagramIcon(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M16 3a5 5 0 0 1 5 5v8a5 5 0 0 1-5 5H8a5 5 0 0 1-5-5V8a5 5 0 0 1 5-5zm-4 5a4 4 0 1 0 0 8 4 4 0 0 0 0-8m0 2a2 2 0 1 1 0 4 2 2 0 0 1 0-4m4.5-3.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
      />
    </svg>
  );
}

export function InstagramColoredIcon(props: IconProps) {
  const id = useId();

  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <defs>
        <radialGradient
          id={`paint0_radial_${id}`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(5.3125 21.5404) rotate(-90) scale(19.8215 18.4355)"
        >
          <stop stopColor="#FFDD55" />
          <stop offset="0.1" stopColor="#FFDD55" />
          <stop offset="0.5" stopColor="#FF543E" />
          <stop offset="1" stopColor="#C837AB" />
        </radialGradient>

        <radialGradient
          id={`paint1_radial_${id}`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(-3.35008 1.4407) rotate(78.681) scale(8.86031 36.5225)"
        >
          <stop stopColor="#3771C8" />
          <stop offset="0.128" stopColor="#3771C8" />
          <stop offset="1" stopColor="#6600FF" stopOpacity="0" />
        </radialGradient>

        <clipPath id={`clip_${id}`}>
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>

      <g clipPath={`url(#clip_${id})`}>
        <path
          d="M15.3125 0H4.6875C2.09867 0 0 2.09867 0 4.6875V15.3125C0 17.9013 2.09867 20 4.6875 20H15.3125C17.9013 20 20 17.9013 20 15.3125V4.6875C20 2.09867 17.9013 0 15.3125 0Z"
          fill={`url(#paint0_radial_${id})`}
        />
        <path
          d="M15.3125 0H4.6875C2.09867 0 0 2.09867 0 4.6875V15.3125C0 17.9013 2.09867 20 4.6875 20H15.3125C17.9013 20 20 17.9013 20 15.3125V4.6875C20 2.09867 17.9013 0 15.3125 0Z"
          fill={`url(#paint1_radial_${id})`}
        />
        <path
          d="M10.0007 2.1875C7.87898 2.1875 7.61266 2.1968 6.77938 2.23469C5.94766 2.27281 5.37992 2.40445 4.8832 2.59766C4.3693 2.79719 3.93344 3.06414 3.49922 3.49852C3.06461 3.93281 2.79766 4.36867 2.5975 4.88234C2.40375 5.37922 2.27195 5.94719 2.23453 6.77852C2.19727 7.61188 2.1875 7.87828 2.1875 10.0001C2.1875 12.1219 2.19688 12.3873 2.23469 13.2206C2.27297 14.0523 2.40461 14.6201 2.59766 15.1168C2.79734 15.6307 3.0643 16.0666 3.49867 16.5008C3.93281 16.9354 4.36867 17.203 4.88219 17.4025C5.3793 17.5957 5.94711 17.7273 6.77867 17.7655C7.61203 17.8034 7.87813 17.8127 9.99977 17.8127C12.1217 17.8127 12.3872 17.8034 13.2205 17.7655C14.0522 17.7273 14.6205 17.5957 15.1177 17.4025C15.6313 17.203 16.0666 16.9354 16.5006 16.5008C16.9352 16.0666 17.2021 15.6307 17.4023 15.117C17.5944 14.6201 17.7262 14.0522 17.7653 13.2208C17.8027 12.3875 17.8125 12.1219 17.8125 10.0001C17.8125 7.87828 17.8027 7.61203 17.7653 6.77867C17.7262 5.94695 17.5944 5.3793 17.4023 4.88258C17.2021 4.36867 16.9352 3.93281 16.5006 3.49852C16.0661 3.06398 15.6315 2.79703 15.1172 2.59773C14.6191 2.40445 14.0511 2.27273 13.2194 2.23469C12.386 2.1968 12.1207 2.1875 9.99828 2.1875H10.0007ZM9.29984 3.59539C9.50789 3.59508 9.74 3.59539 10.0007 3.59539C12.0867 3.59539 12.3339 3.60289 13.1577 3.64031C13.9194 3.67516 14.3328 3.80242 14.6082 3.90938C14.9728 4.05094 15.2327 4.22023 15.506 4.49375C15.7795 4.76719 15.9487 5.02758 16.0906 5.39219C16.1976 5.66719 16.325 6.08063 16.3597 6.84234C16.3971 7.66594 16.4052 7.91328 16.4052 9.99828C16.4052 12.0833 16.3971 12.3307 16.3597 13.1542C16.3248 13.9159 16.1976 14.3294 16.0906 14.6045C15.9491 14.9691 15.7795 15.2287 15.506 15.502C15.2326 15.7754 14.973 15.9446 14.6082 16.0863C14.3331 16.1937 13.9194 16.3206 13.1577 16.3555C12.3341 16.3929 12.0867 16.401 10.0007 16.401C7.91461 16.401 7.66734 16.3929 6.84383 16.3555C6.08211 16.3203 5.66867 16.193 5.39305 16.0861C5.02852 15.9445 4.76805 15.7752 4.49461 15.5018C4.22117 15.2284 4.05195 14.9686 3.91 14.6038C3.80305 14.3287 3.67562 13.9153 3.64094 13.1536C3.60352 12.33 3.59602 12.0827 3.59602 9.99633C3.59602 7.91 3.60352 7.66398 3.64094 6.84039C3.67578 6.07867 3.80305 5.66523 3.91 5.38984C4.05164 5.02523 4.22117 4.76484 4.49469 4.49141C4.7682 4.21797 5.02852 4.04867 5.39312 3.9068C5.66852 3.79938 6.08211 3.67242 6.84383 3.63742C7.56453 3.60484 7.84383 3.59508 9.29984 3.59344V3.59539ZM14.171 4.89258C13.6534 4.89258 13.2335 5.31211 13.2335 5.82977C13.2335 6.34734 13.6534 6.76727 14.171 6.76727C14.6886 6.76727 15.1085 6.34734 15.1085 5.82977C15.1085 5.31219 14.6886 4.89227 14.171 4.89227V4.89258ZM10.0007 5.98797C7.78508 5.98797 5.98867 7.78438 5.98867 10.0001C5.98867 12.2158 7.78508 14.0113 10.0007 14.0113C12.2164 14.0113 14.0122 12.2158 14.0122 10.0001C14.0122 7.78445 12.2163 5.98797 10.0005 5.98797H10.0007ZM10.0007 7.39586C11.4389 7.39586 12.6049 8.56172 12.6049 10.0001C12.6049 11.4383 11.4389 12.6043 10.0007 12.6043C8.5625 12.6043 7.39656 11.4383 7.39656 10.0001C7.39656 8.56172 8.56242 7.39586 10.0007 7.39586Z"
          fill="white"
        />
      </g>
    </svg>
  );
}

export function FacebookIcon(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M13.5 21.888C18.311 21.164 22 17.013 22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 5.013 3.689 9.165 8.5 9.888V15H9a1.5 1.5 0 0 1 0-3h1.5v-2A3.5 3.5 0 0 1 14 6.5h.5a1.5 1.5 0 0 1 0 3H14a.5.5 0 0 0-.5.5v2H15a1.5 1.5 0 0 1 0 3h-1.5z"
      />
    </svg>
  );
}

export function LinkedinIcon(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M18 3a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3zM8 10a1 1 0 0 0-1 1v5a1 1 0 1 0 2 0v-5a1 1 0 0 0-1-1m3-1a1 1 0 0 0-1 1v6a1 1 0 1 0 2 0v-3.66c.305-.344.82-.748 1.393-.993.333-.142.834-.2 1.182-.09a.55.55 0 0 1 .293.188c.052.07.132.226.132.555v4a1 1 0 0 0 2 0v-4c0-.67-.17-1.266-.524-1.744a2.54 2.54 0 0 0-1.301-.907c-.902-.283-1.901-.126-2.568.16a5.82 5.82 0 0 0-.623.312A1 1 0 0 0 11 9M8 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
      />
    </svg>
  );
}

export function XIcon(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M19.753 4.659a1 1 0 0 0-1.506-1.317l-5.11 5.84L8.8 3.4A1 1 0 0 0 8 3H4a1 1 0 0 0-.8 1.6l6.437 8.582-5.39 6.16a1 1 0 0 0 1.506 1.317l5.11-5.841L15.2 20.6a1 1 0 0 0 .8.4h4a1 1 0 0 0 .8-1.6l-6.437-8.582 5.39-6.16Z"
      />
    </svg>
  );
}

export function YoutubeIcon(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M12 4c.855 0 1.732.022 2.582.058l1.004.048.961.057.9.061.822.064a3.802 3.802 0 0 1 3.494 3.423l.04.425.075.91c.07.943.122 1.971.122 2.954 0 .983-.052 2.011-.122 2.954l-.075.91c-.013.146-.026.287-.04.425a3.802 3.802 0 0 1-3.495 3.423l-.82.063-.9.062-.962.057-1.004.048A61.59 61.59 0 0 1 12 20a61.59 61.59 0 0 1-2.582-.058l-1.004-.048-.961-.057-.9-.062-.822-.063a3.802 3.802 0 0 1-3.494-3.423l-.04-.425-.075-.91A40.662 40.662 0 0 1 2 12c0-.983.052-2.011.122-2.954l.075-.91c.013-.146.026-.287.04-.425A3.802 3.802 0 0 1 5.73 4.288l.821-.064.9-.061.962-.057 1.004-.048A61.676 61.676 0 0 1 12 4m-2 5.575v4.85c0 .462.5.75.9.52l4.2-2.425a.6.6 0 0 0 0-1.04l-4.2-2.424a.6.6 0 0 0-.9.52Z"
      />
    </svg>
  );
}

export function SnapchatIcon(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M12 2a6 6 0 0 0-6 6v1.875L5.1 9.2a1 1 0 1 0-1.2 1.6l1.866 1.4c-.444 1.168-1.527 2.39-3.28 3.443a1.01 1.01 0 0 0-.318 1.412C3.286 18.732 5.06 20 7 20c1.784 0 3.007 2 5 2 2.011 0 3.209-2 5-2 1.94 0 3.714-1.268 4.832-2.945a1.01 1.01 0 0 0-.318-1.412c-1.753-1.053-2.836-2.275-3.28-3.443l1.866-1.4a1 1 0 0 0-1.2-1.6l-.9.675V8a6 6 0 0 0-6-6"
      />
    </svg>
  );
}

export function PinterestIcon(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12c0 4.006 2.356 7.462 5.758 9.058l2.29-10.766a1 1 0 0 1 1.956.416C11.73 12 11.49 12.5 11.501 13.1c.017.94.273 1.442.521 1.702.253.265.618.408 1.095.4.487-.01 1.038-.181 1.526-.489C15.592 14.117 16 13.095 16 12a4 4 0 1 0-7.668 1.6 1 1 0 0 1-1.832.8 6 6 0 1 1 11 0c-.368.848-1.04 1.534-1.792 2.007-.755.475-1.657.779-2.555.795-.819.015-1.672-.212-2.359-.808L9.66 21.726c.75.18 1.534.275 2.339.275Z"
      />
    </svg>
  );
}

export function PhoneIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26.43 16.125C25.785 16.125 25.275 15.6 25.275 14.97C25.275 14.415 24.72 13.26 23.79 12.255C22.875 11.28 21.87 10.71 21.03 10.71C20.385 10.71 19.875 10.185 19.875 9.55502C19.875 8.92502 20.4 8.40002 21.03 8.40002C22.53 8.40002 24.105 9.21002 25.485 10.665C26.775 12.03 27.6 13.725 27.6 14.955C27.6 15.6 27.075 16.125 26.43 16.125Z"
        fill="#FF506C"
      />
      <path
        d="M31.845 16.125C31.2 16.125 30.69 15.6 30.69 14.97C30.69 9.645 26.355 5.325 21.045 5.325C20.4 5.325 19.89 4.8 19.89 4.17C19.89 3.54 20.4 3 21.03 3C27.63 3 33 8.37 33 14.97C33 15.6 32.475 16.125 31.845 16.125Z"
        fill="#FF506C"
      />
      <path
        d="M16.575 22.425L13.8 25.2C13.215 25.785 12.285 25.785 11.685 25.215C11.52 25.05 11.355 24.9 11.19 24.735C9.645 23.175 8.25 21.54 7.005 19.83C5.775 18.12 4.785 16.41 4.065 14.715C3.36 13.005 3 11.37 3 9.81C3 8.79 3.18 7.815 3.54 6.915C3.9 6 4.47 5.16 5.265 4.41C6.225 3.465 7.275 3 8.385 3C8.805 3 9.225 3.09 9.6 3.27C9.99 3.45 10.335 3.72 10.605 4.11L14.085 9.015C14.355 9.39 14.55 9.735 14.685 10.065C14.82 10.38 14.895 10.695 14.895 10.98C14.895 11.34 14.79 11.7 14.58 12.045C14.385 12.39 14.1 12.75 13.74 13.11L12.6 14.295C12.435 14.46 12.36 14.655 12.36 14.895C12.36 15.015 12.375 15.12 12.405 15.24C12.45 15.36 12.495 15.45 12.525 15.54C12.795 16.035 13.26 16.68 13.92 17.46C14.595 18.24 15.315 19.035 16.095 19.83C16.245 19.98 16.41 20.13 16.56 20.28C17.16 20.865 17.175 21.825 16.575 22.425Z"
        fill="#FF506C"
      />
      <path
        d="M32.955 27.4951C32.955 27.9151 32.88 28.3501 32.73 28.7701C32.685 28.8901 32.64 29.0101 32.58 29.1301C32.325 29.6701 31.995 30.1801 31.56 30.6601C30.825 31.4701 30.015 32.0551 29.1 32.4301C29.085 32.4301 29.07 32.4451 29.055 32.4451C28.17 32.8051 27.21 33.0001 26.175 33.0001C24.645 33.0001 23.01 32.6401 21.285 31.9051C19.56 31.1701 17.835 30.1801 16.125 28.9351C15.54 28.5001 14.955 28.0651 14.4 27.6001L19.305 22.6951C19.725 23.0101 20.1 23.2501 20.415 23.4151C20.49 23.4451 20.58 23.4901 20.685 23.5351C20.805 23.5801 20.925 23.5951 21.06 23.5951C21.315 23.5951 21.51 23.5051 21.675 23.3401L22.815 22.2151C23.19 21.8401 23.55 21.5551 23.895 21.3751C24.24 21.1651 24.585 21.0601 24.96 21.0601C25.245 21.0601 25.545 21.1201 25.875 21.2551C26.205 21.3901 26.55 21.5851 26.925 21.8401L31.89 25.3651C32.28 25.6351 32.55 25.9501 32.715 26.3251C32.865 26.7001 32.955 27.0751 32.955 27.4951Z"
        fill="#FF506C"
      />
    </svg>
  );
}

export function MessagePinIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.5 21H12.975C13.175 21 13.369 20.9625 13.557 20.8875C13.745 20.8125 13.9135 20.7 14.0625 20.55L21.075 13.5C21.3 13.275 21.469 13.0185 21.582 12.7305C21.695 12.4425 21.751 12.1615 21.75 11.8875C21.749 11.6135 21.693 11.345 21.582 11.082C21.471 10.819 21.3145 10.575 21.1125 10.35L19.725 8.925C19.5 8.7 19.25 8.5315 18.975 8.4195C18.7 8.3075 18.4125 8.251 18.1125 8.25C17.8375 8.25 17.5625 8.3065 17.2875 8.4195C17.0125 8.5325 16.7625 8.701 16.5375 8.925L9.45 15.9375C9.3 16.0875 9.1875 16.2565 9.1125 16.4445C9.0375 16.6325 9 16.826 9 17.025V19.5C9 19.925 9.144 20.2815 9.432 20.5695C9.72 20.8575 10.076 21.001 10.5 21ZM18.075 13.35L16.65 11.9625L18.1125 10.5L19.5 11.925L18.075 13.35ZM16.8 21H25.5C25.925 21 26.2815 20.856 26.5695 20.568C26.8575 20.28 27.001 19.924 27 19.5C26.999 19.076 26.855 18.72 26.568 18.432C26.281 18.144 25.925 18 25.5 18H19.8L16.8 21ZM9 27L5.55 30.45C5.075 30.925 4.531 31.0315 3.918 30.7695C3.305 30.5075 2.999 30.0385 3 29.3625V6C3 5.175 3.294 4.469 3.882 3.882C4.47 3.295 5.176 3.001 6 3H30C30.825 3 31.5315 3.294 32.1195 3.882C32.7075 4.47 33.001 5.176 33 6V24C33 24.825 32.7065 25.5315 32.1195 26.1195C31.5325 26.7075 30.826 27.001 30 27H9Z"
        fill="white"
      />
    </svg>
  );
}
